export default __webpack_public_path__ + "static/media/avatar1.eeef2af6.png";